/**
 * KÖRVONAL — seasonal gift-card placements (see sections/korvonal-gc-placement.liquid
 * for the switch, the placement ids and the tracking contract).
 *
 * Loaded once per rendered placement (defer), so everything here is
 * idempotent. It does three things the Liquid cannot:
 *   - preview: ?gc_preview=1 marks the session (sessionStorage `kvgc_prev`,
 *     the same key assets/korvonal-cutoff.js reads), ?gc_preview=0 clears it;
 *     a placement rendered in preview mode stays hidden without the mark;
 *   - moves a band's FAQ answer into the page's own `.kvfaq` list, and the
 *     band itself above that list when asked to;
 *   - puts the tile into the collection grid (`.collection.grid`), the same
 *     anchor korvonal-bundle-grid and the advisor tile use. If the grid
 *     markup ever changes the tile simply does not appear.
 */
(function () {
  'use strict';

  var KEY = 'kvgc_prev';
  var preview = false;
  try {
    var p = new URLSearchParams(location.search).get('gc_preview');
    if (p === '0' || p === 'off') sessionStorage.removeItem(KEY);
    else if (p) sessionStorage.setItem(KEY, '1');
    preview = sessionStorage.getItem(KEY) === '1';
  } catch (e) { /* storage blocked: preview unavailable, on-mode unaffected */ }

  function mountTile(el) {
    var grid = document.querySelector('.collection.grid');
    var tpl = el.querySelector('template');
    if (!grid || !tpl || grid.querySelector('.kvgc-tile')) return;
    var cards = grid.querySelectorAll('.product-item');
    var at = parseInt(el.getAttribute('data-kvgc-at'), 10) || 0;
    grid.insertBefore(tpl.content.firstElementChild.cloneNode(true), cards[at] || null);
  }

  function mount(el) {
    if (el.hasAttribute('data-kvgc-done')) return;
    el.setAttribute('data-kvgc-done', '');
    if (el.getAttribute('data-kvgc-mode') === 'preview' && !preview) return;
    if (el.getAttribute('data-kvgc-layout') === 'tile') return mountTile(el);

    var list = document.querySelector('.kvfaq');
    var faq = el.querySelector('.kvgc__faq');
    if (faq && list) {
      faq.className = '';
      list.appendChild(faq);
    }
    if (list && el.hasAttribute('data-kvgc-before-faq')) {
      var head = list.previousElementSibling;
      var anchor = head && /^H[2-3]$/.test(head.tagName) ? head : list;
      anchor.parentNode.insertBefore(el, anchor);
    }
    el.hidden = false;
  }

  function run() {
    var els = document.querySelectorAll('[data-kvgc]');
    for (var i = 0; i < els.length; i++) mount(els[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
